import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=7a8e690b&"
import script from "./Profile.js?vue&type=script&lang=js&"
export * from "./Profile.js?vue&type=script&lang=js&"
import style0 from "./Profile.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports